let route = null;
import { inject } from "vue";
import { useAssetTransforms } from "@/Composables";

export default function () {
    route = route ? route : inject("route");
    const { marketingAssetUrl } = useAssetTransforms();

    const jsonLdMainEntityBlogIndex = (articles, categories) => {
        let hasPart = [];
        let tags = [];

        articles.data.forEach((article, index) => {
            hasPart.push({
                "@type": "Article",
                name: article.title,
                url: route("web.education.show", article.slug),
            });
        });

        categories.forEach((category, index) => {
            tags.push({
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": route("web.education.category.show", category.slug),
                    name: category.name,
                },
            });
        });

        return {
            "@type": "CollectionPage",
            "@id": route(route().current(), route().params),
            name: "Blog Articles",
            description: "A paginated index of blog articles",
            hasPart: {
                "@type": "ItemList",
                name:
                    "Page " + articles.current_page + " of Blog Articles",
                url: route(route().current(), route().params),
                numberOfItems: articles.total,
                hasPart: hasPart,
            },
            next: articles.next_page_url,
            prev: articles.prev_page_url,
            mentions: tags,
        };
    };

    const jsonLdMainEntityBlogShow = (article) => {
        let mentions = [];

        article.categories?.forEach((tag, index) => {
            mentions.push({
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": route("web.education.category.show", tag.slug),
                    name: tag.name,
                },
            });
        });

        let mainEntity = {
            "@type": "Article",
            "@id": route("web.education.show", article.slug),
            name: article.title,
            description: article.headline,
            datePublished: article.published_at,
            dateModified: article.updated_at,
            author: {
                "@type": "Organization",
                name: "SECLOCK",
            },
        };

        if (article.image) {
            mainEntity.image = marketingAssetUrl(article.image);
        }

        if (mentions.length) {
            mainEntity.mentions = mentions;
        }
        return mainEntity;
    };

    const jsonLdMainEntityManufacturers = (manufacturers) => {
        let itemListElement = [];

        manufacturers.forEach((manufacturer, index) => {
            let productTypeArray = [];

            if(manufacturer.tags['vendor-category']){
                manufacturer.tags['vendor-category'].forEach((tag, index) => {
                    productTypeArray.push({
                        "@type": "ListItem",
                        position: index + 1,
                        name: tag.name,
                    });
                });
            }

            let productTypes = {
                "@type": "ItemList",
                "@name": "Product Categories",
                description:
                    "A list of product categories supplied by " +
                    manufacturer.display_name,
                itemListElement: productTypeArray,
            };

            itemListElement.push({
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@type": "Organization",
                    name: manufacturer.display_name,
                    logo: manufacturer.logo?.url,
                    url: route(
                        "web.catalog.manufacturers.show",
                        manufacturer.slug
                    ),
                    mainEntityOfPage: {
                        "@type": "WebPage",
                        "@id": route(
                            "web.catalog.manufacturers.show",
                            manufacturer.slug
                        ),
                    },
                    productTypes: productTypes,
                },
            });
        });

        return {
            "@type": "WebPage",
            "@id": route(route().current(), route().params),
            name: "Manufacturers",
            description:
                "A collection of manufacturers who supply products to the site.",
            url: route(route().current(), route().params),
            mainEntity: {
                "@type": "CollectionPage",
                name: "Manufacturers List",
                description:
                    "A collection of manufacturers who supply products to the site.",
                itemListElement: itemListElement,
            },
        };
    };

    const jsonLdMainEntityManufacturer = (manufacturer, series) => {
        let seriesData = [];

        series.forEach((serie, index) => {
            seriesData.push({
                "@type": "ListItem",
                position: index + 1,
                name: serie.name,
            });
        });

        let mainEntity = {
            "@type": "WebPage",
            "@id": route(route().current(), route().params),
            name: manufacturer.name,
            description:
                manufacturer.name +
                " is a manufacturer that supplies product to SECLOCK.",
            url: route(route().current(), route().params),
        };

        if (seriesData.length) {
            // mainEntity.hasPart = {
            //     "@type": "ItemList",
            //     name:
            //         "Page 1" +
            //         series.meta.current_page +
            //         " of " +
            //         series.meta.last_page +
            //         "1 pages of Series offered by " +
            //         manufacturer.display_name,
            //     numberOfItems: series.meta.total,
            //     itemListElement: seriesData,
            //     prev: series.meta.prev,
            //     next: series.meta.next,
            // };
        }

        return mainEntity;
    };

    const jsonLdMainEntityWebPage = (title, description) => {
        return {
            "@type": "WebPage",
            "@id": route(route().current(), route().params),
            name: title,
            description: description,
            url: route(route().current(), route().params),
        };
    };

    return {
        jsonLdMainEntityBlogIndex,
        jsonLdMainEntityBlogShow,
        jsonLdMainEntityManufacturer,
        jsonLdMainEntityManufacturers,
        jsonLdMainEntityWebPage,
    };
}
